import { useState, useEffect, useContext } from 'react';
import { useNavigate , useParams, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth'; 
// import { atualizarDocAprovacao, excluirDocAprovacao } from '../../services/api';
import { incluirDocAprovacao, alterarDocAprovacao, excluirDocAprovacao } from '../../services/apigateway';

import { toast } from 'react-toastify';
import { getS3Url } from '../../services/funcoes';

import { TbPhotoSearch } from 'react-icons/tb';

import Globais from '../../components/Globais/Globais'; 
import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

import ModalSenha from '../../components/Modal/modalsenha';
import ModalArquivo from '../../components/Modal/modalarquivo';

export default function DocumentoAprovacao({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);
  const { numero, ordemId, nomeEquipamento, equipamentoId, idtDocAprovacao } = useParams();

  // const readOnly = (funcao === 'Exclusão');

  const history = useNavigate();

  const [loading, setLoading] = useState(false);

  const [nomeDocAprovacao, setNomeDocAprovacao] = useState('');
  const [docAprovacao, setDocAprovacao] = useState('');
  const [operacaoDocumento, setOperacaoDocumento] = useState('Consulta');

  const [mostrarModalSenha, setMostrarModalSenha] = useState(false);
  const [mostrarModalDocAprovacao, setMostrarModalDocAprovacao] = useState(false);
  const [previewDocAprovacao, setPreviewDocAprovacao] = useState(null);

  useEffect(()=>{
    if (funcao !== 'Inclusão' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModalSenha(true);
    }

    if (funcao !== 'Inclusão') {
      setNomeDocAprovacao(idtDocAprovacao);
      setPreviewDocAprovacao(getS3Url(idtDocAprovacao, 'Documento') + `?t=${Date.now()}`);
    }

    setOperacaoDocumento(funcao);
  }, []);

  function autorizado() { setMostrarModalSenha(false) }

  function naoAutorizado() {
    setMostrarModalSenha(false);
    history(`/ordens/consulta/${ordemId}`);
  }

  async function executaAcao(e){
    e.preventDefault();

    console.log('executaAcao: ', funcao);

    const documento = {
      clienteId: clienteId, 
      ordemId: ordemId,
      idtDocAprovacao: nomeDocAprovacao,
      docAprovacao: docAprovacao,
      operacaoDocumento: operacaoDocumento
    }

    console.log('Documento: ', documento);

    if (funcao === 'Inclusão') {
      //INSERT
      try {
        const response = await incluirDocAprovacao(documento);
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          toast.error(`Erro ao incluir documento de aprovação: ${response.mensagem}`);
        }
      } catch (err) {
        toast.error('Error ', err);

      } finally {
        setLoading(false);
      }  
    }

    if (funcao === 'Alteração') {
      try {
        const response = await alterarDocAprovacao(documento);
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          toast.error(`Erro ao atualizar documento de aprovação: ${response.mensagem}`);
        }

      } catch (err) {
        toast.error('Erro ao atualizar documento');

      } finally {
        setLoading(false);
      }  
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        const response = await excluirDocAprovacao(documento);
      
        if (response.codigo === '000') {
          toast.success('Documento excluído com sucesso!!');
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          let mensagem = '';

          if (response.retorno === 'ER_ROW_IS_REFERENCED_2') {
            mensagem = 'Documento não pode ser excluído!'

          } else {
            mensagem = `Erro ao excluir documento: ${response.mensagem}`
          }
          toast.error(mensagem);
        }
      } catch (err) {
        toast.error('Erro ao excluir documento');

      } finally {
        setLoading(false);
      }  
    }

    return;
  }

  function selecionarDocumento(file) {
    setDocAprovacao(file);
    setPreviewDocAprovacao(URL.createObjectURL(file));
    ((idtDocAprovacao === '') ? setOperacaoDocumento('Inclusão') : (setOperacaoDocumento('Alteração')));
  }

  function limpaArquivo() {
    setDocAprovacao('');
    setPreviewDocAprovacao(null);
    ((idtDocAprovacao === '') ? setOperacaoDocumento('Consulta') : (setOperacaoDocumento('Exclusão')));
  }

  function handleSair(e){
    history(`/ordens/consulta/${ordemId}`);
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Documento de Aprovação'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Documento...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (mostrarModalSenha) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Documento de Aprovação ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>

            <h3 className='font-semibold text-lg mb-3 mt-1'>Ordem de Manutenção: {numero}</h3>
            <h3 className='font-semibold text-lg mb-3 mt-1'>Equipamento: {nomeEquipamento}</h3>

            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-100 p-4 rounded shadow">
                  <h3 className="text-lg font-semibold text-blue-700 mb-3">Documento de Aprovação</h3>

                  <div className="flex items-center gap-2">
                    <label className="text-sm font-medium text-gray-700">Documento: </label>
                    {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                        <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalDocAprovacao(true)}>
                          <TbPhotoSearch size={16} /> 
                        </button>
                    )}

                    {/* {(funcao === 'Alteração' && (docAprovacao || previewDocAprovacao)) && (
                        <button type='button'onClick={() => limpaArquivo()}>
                          <FaCircleXmark color='blue' size={16} />
                        </button>
                    )} */}
                  </div>

                  <div>
                    {(funcao === 'Inclusão' && docAprovacao) && (
                          <div className="relative">
                            <iframe
                              src={previewDocAprovacao}
                              title="Visualização do PDF"
                              className="w-full h-96 border rounded"
                            />
                          </div>
                    )}

                    {(funcao !== 'Inclusão' && previewDocAprovacao) && (
                          <div className="relative">
                            <iframe
                              src={previewDocAprovacao}
                              title="Visualização do PDF"
                              className="w-full h-96 border rounded"
                            />
                          </div>
                    )}

                    <ModalArquivo
                      isOpen={mostrarModalDocAprovacao}
                      onClose={() => setMostrarModalDocAprovacao(false)}
                      onSelecionar={(file) => selecionarDocumento(file)}
                      titulo='Documento'
                    />
                  </div>

                </div>
              </div>
            </div>

            <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
          </section>
        </section>

      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
